import { __assign } from "tslib";
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { NumericInput } from './numeric-input';
import { renderAndMountComponent } from '@wix/answers-lib';
export var createLegacyNumericInputDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.numeric-input', NumericInput.name);
    var numericInput = baseDriver.find('input');
    var simulateMouseDown = function (elem) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('mousedown', true, false);
        elem.dispatchEvent(event);
    };
    return {
        getValue: function () { return parseInt(numericInput.elem.value, 10); },
        enterValue: function (value) { return numericInput.enterValue(value.toString()); },
        isDisabled: function () { return !!numericInput.getAttribute('disabled'); },
        clickIncrement: function () { return simulateMouseDown(baseDriver.find('.increment').elem); },
        clickDecrement: function () { return simulateMouseDown(baseDriver.find('.decrement').elem); }
    };
};
export var createLegacyNumericInput = function (props) {
    var elem = renderAndMountComponent(React.createElement(NumericInput, __assign({}, props)));
    return createLegacyNumericInputDriver(elem);
};
//# sourceMappingURL=numeric-input.legacy-driver.js.map